<template>
  <div class="section">
    <div class="container">
      <div class="columns is-centered has-text-centered">
        <div class="column is-10">
          <p>
            <code class="has-text-black is-size-4-desktop">
              {{ tutorCode }}
            </code>
          </p>
          <p>
            Give this code to users who want to connect to you as students.
          </p>
          <br />
          <b-button
            type="is-info"
            size="is-small"
            @click="fetchStudents"
            :loading="loadingStudents"
          >
            Refresh students list
          </b-button>
          <br />
          <p v-if="!students.length" class="has-text-grey mt-4">
            Currently, you have no students.
          </p>
          <MyStudents v-else :students="students" @disconnect="fetchStudents" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyStudents from "../components/Students/MyStudents";
import dataService from "../services/dataService";
export default {
  components: { MyStudents },
  data() {
    return {
      tutorCode: "loading...",
      loadingStudents: false,
      students: []
    };
  },
  methods: {
    async fetchStudents() {
      this.loadingStudents = true;
      this.students = await dataService.getStudents();
      this.loadingStudents = false;
    }
  },
  async created() {
    this.tutorCode = await dataService.getTutorCode();
    this.fetchStudents();
  }
};
</script>

<style lang="scss" scoped></style>
